if (window.innerWidth < 768) {

document.querySelectorAll('.Categories').forEach(element => {
    element.addEventListener('click', (event) => {
      event.preventDefault();  // Prevent the default behavior of adding '#' to the URL
      document.documentElement.classList.add("open_menu");
      document.querySelector('.mask-overlay').classList.add('mask_opened');
    });
});

document.querySelector('.js-close-sidebar').addEventListener('click', () => {
  document.querySelectorAll('.Categories').forEach(element => {
    element.classList.remove('active');
  });
});

document.querySelector(".Scanner").addEventListener("click", function() {
    document.querySelector(".container_div").style.display = "block";
  });
document.querySelector(".close-icon").addEventListener("click", function() {
    document.querySelector(".container_div").style.display = "none";
  });

document.addEventListener("DOMContentLoaded", function () {
    const navItems = document.querySelectorAll(".bottom-nav-item");

    // Ensure the first item with the .Home class gets the 'active' class by default
    const firstItem = document.querySelector(".bottom-nav-item.Home");
    if (firstItem) {
        firstItem.classList.add("active");
    }

    // Add event listeners to all items
    navItems.forEach(item => {
        item.addEventListener("click", function () {
            // If the clicked item is already active, remove the active class
            if (item.classList.contains("active")) {
                item.classList.remove("active");
            } else {
                // Remove 'active' class from all items
                navItems.forEach(i => i.classList.remove("active"));

                // Add 'active' class to the clicked item
                item.classList.add("active");
            }
        });
    });
});
document.addEventListener("DOMContentLoaded", function () {
 const closePopupButtonbrowse = document.querySelector(".browse_parts .close-popup");
const searchButton = document.querySelector(".bottom-nav-item.Search");
const overlaySearch = document.querySelector(".overlay_search");
const advanceSearchLink = document.querySelector(".advance_search_p");
const advancePopup = document.querySelector(".advance-search-popup");
const footerhead = document.querySelector("footer.header");
const advanceheader = document.querySelector(".advance_header");
const bodytag = document.querySelector('body');
const browse_parts = document.querySelector('.browse_parts');
const main_browser_parts = document.querySelector('.main_browser_parts');

  if(browse_parts){
    browse_parts.addEventListener("click", function () {
        overlaySearch.style.display = "block";
    });
 } 
if(closePopupButtonbrowse){
  closePopupButtonbrowse.addEventListener("click", function () {
    let $room = document.getElementById('room-type'),
        $appl = document.getElementById('appliance-type'),
        $model = document.getElementById('model');
    
    // Restore default dropdown selection
    if ($room) {
        $room.selectedIndex = 0; // Reset room-type dropdown
    }
    
    if ($appl) {
        $appl.innerHTML = ""; // Clear appliance-type dropdown
    }

    if ($model) {
        $model.innerHTML = ""; // Clear model dropdown
    }

    // Reset all <option> elements inside the dropdowns
    document.querySelectorAll("select").forEach(select => {
        if (select.options.length > 0) {
            select.selectedIndex = 0; // Reset to default
        }
    });

    // Reset page layout
    bodytag.style.overflow = "unset";
    main_browser_parts.classList.remove("show-class");
    searchButton.classList.remove("active");
    advancePopup.style.display = "none";
    overlaySearch.style.display = "none";
    footerhead.style.zIndex = "";
});
}
});
document.addEventListener("DOMContentLoaded", function () {
// var shopLocale = "{{ request.locale.iso_code }}"; 
//   var shopCountry = "{{ localization.country.iso_code }}";
//  var shopLocale = "{{ request.locale.iso_code }}"; 
//   var shopCountry = "{{ localization.country.iso_code }}";

  const localeEl = document.getElementById("locale-data");
  const shopLocale = localeEl.dataset.locale;
  const shopCountry = localeEl.dataset.country;
    console.log("shopLocale amp", shopLocale, " ", shopCountry)
      if (shopLocale === 'fr' && shopCountry === 'CA') {
        // setTimeout(() => {
            var searchButton = document.querySelector(".bottom-nav-item.Recherche");
        // }, 3000);
        
      }else{
        var searchButton = document.querySelector(".bottom-nav-item.Search");
      }

    
    const overlaySearch = document.querySelector(".overlay_search");
    const advanceSearchLink = document.querySelector(".advance_search_p");
    const advancePopup = document.querySelector(".advance-search-popup");
    const closePopupButton = document.querySelector(".close-popup");
    const footerhead = document.querySelector("footer.header");
    const advanceheader = document.querySelector(".advance_header");
    const bodytag = document.querySelector('body');
    const main_browser_parts = document.querySelector('.main_browser_parts');
    console.log("advance-search-popup", searchButton, "advanceSearchLink", advanceSearchLink)

    if (!searchButton) return; // Exit if search button is not found

    if (document.body.classList.contains("template-index")) {
        // When clicking on the Search button, toggle the overlay
        searchButton.addEventListener("click", function (event) {
            event.preventDefault();
            footerhead.style.zIndex = "100";
            advanceheader.style.zIndex = "100";

            window.scrollTo({ top: 0, behavior: "smooth" });

            // Toggle overlay visibility
            overlaySearch.style.display = overlaySearch.style.display === "block" ? "none" : "block";
        });

        if (advanceSearchLink && advancePopup) {
            advanceSearchLink.addEventListener("click", function (event) {

                event.preventDefault();

                if (advancePopup.style.display === "block") {
                    main_browser_parts.classList.remove("show-class");
                    searchButton.classList.remove("active");
                    advancePopup.style.display = "none";
                    footerhead.style.zIndex = "";
                } else {
                  main_browser_parts.classList.add("show-class");
                    searchButton.classList.remove("active");
                    advancePopup.style.display = "block";
                    footerhead.style.zIndex = "10";
                }
            });
        }

        if (closePopupButton) {
            closePopupButton.addEventListener("click", function () {
              let $room = document.getElementById('room-type'),
                  $appl = document.getElementById('appliance-type'),
                  $model = document.getElementById('model'),
                  $option = document.querySelector('option');
              
                bodytag.style.overflow = "unset";
               main_browser_parts.classList.remove("show-class");
                searchButton.classList.remove("active");
                advancePopup.style.display = "none";
                overlaySearch.style.display = "none";
                footerhead.style.zIndex = "";
              
                $room.options[$room.selectedIndex].selected=false;
                $appl.innerHTML = "";
                $model.innerHTML = "";
              
            });
        }

        // Close popup if clicked outside
        document.addEventListener("click", function (event) {
            if (
                !searchButton.contains(event.target) &&
                !advanceSearchLink.contains(event.target) &&
                !advancePopup.contains(event.target)
            ) {
               bodytag.style.overflow = "unset";
              searchButton.classList.remove("active");
                overlaySearch.style.display = "none";
                advancePopup.style.display = "none";
                footerhead.style.zIndex = "";
            }
        });
    } else {
        // If it's NOT the "home" page, clicking the search button should trigger another search input
      searchButton.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent the default anchor behavior
         

            // Check if 'active' class is added to searchButton, then trigger the search input
            if (searchButton.classList.contains("active")) {
                const alosearchElement = document.querySelector(".search_header__input");
                if (alosearchElement) {
                    alosearchElement.click();
                }
            }
        });
    }
});







}  
